import './lagneaux/style';
import FormStructure from './lagneaux/form_structure';

export default FormStructure;